import { InjectionScope } from '@awesome-nodes/injection-factory';
export const ENVIRONMENT_TOKEN = InjectionScope.get(Symbol('ENVIRONMENT'), null).addToken('ENVIRONMENT_TOKEN');
